import { AddOn } from './AddOn';

export class WebinarSeries extends AddOn {
  public get shortDescription(): string {
    return 'Organize your webinars into series and give every customer a personalized landing page that tracks their progress. Includes the Universal Dashboard.';
  }

  public get description(): string {
    return 'Organize your webinars into series and give every customer a personalized landing page that tracks their progress. Includes the Universal Dashboard. Create structured learning paths, track participant progress, and provide a seamless experience across multiple webinars.';
  }

  public image(): string | null {
    return require('$/images/logos/webinar-series.png').default;
  }
}
